// Fichier : src/redux/slices/importDoctors/importPersonsThunk.js (VERSION CORRIGÉE)

import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, API_URL } from "../../../config/api";
import axiosService from "../../../services/axiosServices";

// On reconstruit l'URL complète de l'endpoint d'import des docteurs
const api_url = `${API_URL}${API.API_PREFIX || '/api'}${API.VERSION || '/v1'}${API.PERSONS?.BASE || "/persons"}/import/doctors?format=csv`;

export const uploadDoctorFile = createAsyncThunk(
  'upload/file', 
  async (originalFormData, { rejectWithValue }) => {
    try {
      // On récupère le fichier original du FormData envoyé par le composant
      const originalFile = originalFormData.get('file');

      // Si aucun fichier n'est trouvé, on retourne une erreur.
      if (!originalFile) {
        return rejectWithValue("Aucun fichier fourni.");
      }

      // On crée une copie du fichier en forçant son type MIME à 'text/csv'
      const correctedFile = new Blob([originalFile], { type: 'text/csv' });

      // On crée un nouveau FormData et on y ajoute notre fichier corrigé
      const correctedFormData = new FormData();
      correctedFormData.append('file', correctedFile, originalFile.name);

      // On envoie ce nouveau FormData à l'API
      const response = await axiosService.post(api_url, correctedFormData, {
        headers: {
          // 'Content-Type': 'multipart/form-data' est ajouté automatiquement par axios pour les FormData
        },
      });
      return response.data; 

    } catch (error) {
      // Gestion améliorée des erreurs
      const errorMessage = error.response?.data?.message || error.message || "Une erreur inconnue est survenue.";
      return rejectWithValue(errorMessage);
    }
  }
);
